import { bunja } from 'bunja';
import { atom } from 'jotai';

import segment from '.';

export const segmentBunja = bunja(() => {
  /**
   * https://segment.com/docs/connections/destinations/catalog/actions-amplitude/#device-id-mappings
   * segment anonymousId가 amplitude의 deviceId로 매핑됨
   */
  const anonymousIdAtom = atom<string>('');
  anonymousIdAtom.onMount = (set) => {
    segment.getAnonymousId().then((id) => {
      set(id ?? '');
    });
  };

  return {
    anonymousIdAtom,
  };
});
